/**
 * French labels for the stripe `requirements.currently_due` machine keys.
 *
 * Matching is prefix based: stripe keys are dotted paths whose leaves are
 * often split (`individual.dob.day`, `individual.dob.month`, …) while the
 * pharmacist only needs the field family. First matching prefix wins, so
 * specific prefixes must be listed before broader ones.
 */
const REQUIREMENT_LABELS: [prefix: string, label: string][] = [
    ['external_account', 'Coordonnées bancaires'],
    ['tos_acceptance', 'Acceptation des conditions d\'utilisation Stripe'],
    ['business_profile.mcc', 'Catégorie d\'activité'],
    ['business_profile.url', 'Site web ou description de l\'activité'],
    ['business_profile', 'Informations sur l\'activité'],
    ['business_type', 'Type d\'activité'],
    ['individual.verification', 'Justificatif d\'identité'],
    ['individual.dob', 'Date de naissance du représentant'],
    ['individual.address', 'Adresse du représentant'],
    ['individual.email', 'Email du représentant'],
    ['individual.phone', 'Téléphone du représentant'],
    ['individual', 'Informations sur le représentant'],
    ['representative', 'Informations sur le représentant'],
    ['company.verification', 'Justificatif d\'immatriculation'],
    ['company', 'Informations sur la société'],
    ['person', 'Informations sur les dirigeants'],
];

const GENERIC_REQUIREMENT_LABEL = 'Informations complémentaires demandées par Stripe';

/**
 * Translate stripe requirement keys into pharmacist friendly labels,
 * deduplicated. Unknown keys collapse into a single generic entry — the
 * stripe hosted onboarding re-collects them itself anyway.
 */
export function labelStripeRequirements(keys: string[]): string[] {
    const labels = keys.map((key) => {
        const match = REQUIREMENT_LABELS.find(([prefix]) => key.startsWith(prefix));

        return match ? match[1] : GENERIC_REQUIREMENT_LABEL;
    });

    return [...new Set(labels)];
}
